import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { RuleVersion } from '../api-types';
import { formatDate } from '../format';
import { useTargetClass } from './target';

/** The versions, newest first; a version opens to «Cosa è cambiato» and «Perché». */
export function HistoryList({ versions }: { readonly versions: readonly RuleVersion[] }) {
  const { t } = useTranslation('archive');
  const marked = useTargetClass('versione');
  return (
    <section
      id="versione"
      aria-labelledby="storico-title"
      className={`bg-card border-border scroll-mt-4 rounded-md border p-4 ${marked ?? ''}`}
    >
      <h3 id="storico-title" className="text-lg font-bold">
        {t('rules.history')}
      </h3>
      <ul className="m-0 mt-2 list-none p-0">
        {versions.map((version) => (
          <li key={version.version} className="border-border border-t first:border-t-0">
            <details>
              <summary className="flex min-h-11 cursor-pointer list-none items-center gap-2 font-semibold">
                <ChevronRight aria-hidden="true" className="size-4 shrink-0" />
                {t('rules.versionRow', {
                  version: version.version,
                  status: t(`rules.${statusKey(version.status)}`),
                  date: formatDate(version.date),
                })}
              </summary>
              <div className="bg-muted/50 mb-3 rounded-md p-3 text-sm">
                <p className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
                  {t('rules.changes')}
                </p>
                <p className="mb-2">{version.changes}</p>
                <p className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
                  {t('rules.why')}
                </p>
                <p>{version.why}</p>
              </div>
            </details>
          </li>
        ))}
      </ul>
    </section>
  );
}

function statusKey(status: string): 'proposal' | 'approved' | 'draft' {
  if (status === 'proposta') return 'proposal';
  if (status === 'approvata') return 'approved';
  return 'draft';
}
